import { Link } from 'react-router-dom';
import heroImage from '@/assets/thehubpub_hero_header.jpg';
import styles from './HomePage.module.css';

function HomePage() {
  return (
    <div className={styles.page}>
      <section className={styles.hero} style={{ backgroundImage: `url(${heroImage})` }}>
        <h1 className={styles.heroTitle}>The Friendliest Pub in the Hub!</h1>
      </section>

      <section className={styles.hoursSection}>
        <h1 className={styles.sectionTitle}>Cocktails, Beer, Billiards, and, Fine Pub Dining</h1>
        <h5 className={styles.subHeading}>Hours</h5>
        <h2 className={styles.hoursDay}>Monday - Saturday</h2>
        <h3 className={styles.hoursTime}>Open 11am to 2am</h3>
        <h2 className={styles.hoursDay}>Sunday</h2>
        <h3 className={styles.hoursTime}>Open 12pm to 2am</h3>
        <br />
        <Link to="/menu" className={styles.sectionLink}>See pub dining menu &#10148;</Link>
      </section>

      <section className={styles.giftSection}>
        <h3 className={styles.subHeading}>Gift Cards and Merchandise Available</h3>
        <h4 className={styles.giftText}>
          Make your next private event a memorable one and book it at Hub Pub!
          <br />
          <Link to="/parties" className={styles.sectionLink}>Learn more &#10148;</Link>
        </h4>
      </section>

      <section className={styles.faqSection}>
        <h3 className={styles.subHeading}>Want more info?</h3>
        <h2 className={styles.faqText}>See our frequently asked questions</h2>
        <br />
        <Link to="/about" className={styles.faqLink}>FAQ &#10148;</Link>
      </section>

      <section className={styles.gameSection}>
        <h2 className={styles.gameText}>Play pool in our upstairs loft!</h2>
      </section>
    </div>
  );
}

export default HomePage;
